import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useChargingActivityDownload } from '@/api/chargingActivity';
import type {
    DownloadDropdownButtonProps,
    FileFormat,
} from '@/features/chargingActivity/components/DownloadDropdownButton/types';
import { useDownloadOptions } from '@/features/chargingActivity/hooks/useDownloadOptions';

export const DownloadDropdownButton = ({ disabled, filters }: DownloadDropdownButtonProps) => {
    const { locale } = useIntl();

    const [isOpen, setIsOpen] = useState(false);

    const { mutateAsync: downloadActivity, isLoading } = useChargingActivityDownload();

    const handleDownload = async (format: FileFormat) => {
        try {
            await downloadActivity({
                export: {
                    format,
                    locale,
                },
                filters,
            });
        } catch {
            Notification.error(<FormattedMessage id='general.saveChanges.errorMessage' />);
        }
    };

    const options = useDownloadOptions(handleDownload);

    const dropdownContent = (
        <div className='padding-5'>
            {options.map((option, index) =>
                option.header ? (
                    <div key={`option_${index}`} className='padding-x-10 padding-y-5 text-color-gray' role='note'>
                        <strong>
                            <i>{option.value}</i>
                        </strong>
                    </div>
                ) : (
                    <button
                        key={`option_${index}`}
                        onClick={() => {
                            option.onSelect?.();
                            setIsOpen(false);
                        }}
                        className='btn width-100pct text-color-black hover-bg-lighter text-left rounded-small bg-white justify-content-start'
                        style={{ padding: '7px 13px' }}
                        type='button'
                    >
                        {option.value}
                    </button>
                )
            )}
        </div>
    );

    return (
        <div className='position-relative' style={{ marginTop: '13px' }}>
            <ButtonDropdown
                title={<span className={`${!isLoading && 'rioglyph rioglyph-download'}`} />}
                toggleClassName={`${isLoading && 'btn btn-default btn-icon-only btn-loading'}`}
                iconOnly
                className='width-250'
                disabled={disabled || isLoading}
                customDropdown={dropdownContent}
                open={isOpen}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
            />
        </div>
    );
};
